import * as types from "./actionTypes";

export const dateAndTimeMaintain = data => {
  return {
    type: types.MAINTAIN_DATE_AND_TIME,
    payLoad: data
  };
};

export const savedInfo = data => {
  return {
    type: types.SAVE_INFO_FOR_CASH_PURPOSE,
    payLoad: data
  };
};

export const setConfirmDataForTable = data => {
  return {
    type: types.SET_CONFIRM_DATA_FOR_TABLE,
    data: data
  };
};

export const closeConfirmForTable = () => {
  return {
    type: types.CLOSE_CONFIRM_FOR_TABLE
  };
};

export const toggleSelectModeForTable = status => {
  return {
    type: types.TOGGLE_SELECT_MODE_FOR_TABLE,
    status: status
  };
};


export const setModalDataForLongError = data => {
  return {
    type: types.SET_MODAL_DATA_FOR_LONG_ERROR,
    data: data
  };
};

export const closeModalForLongError = () => {
  return {
    type: types.CLOSE_MODAL_FOR_LONG_ERROR
  };
};